import { render, staticRenderFns } from "./ProjectDetailsHeader.vue?vue&type=template&id=17128d02&scoped=true"
import script from "./ProjectDetailsHeader.vue?vue&type=script&lang=js"
export * from "./ProjectDetailsHeader.vue?vue&type=script&lang=js"
import style0 from "./ProjectDetailsHeader.vue?vue&type=style&index=0&id=17128d02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17128d02",
  null
  
)

export default component.exports